import { Box, Heading, Text, VStack, SimpleGrid, Flex } from '@chakra-ui/react'
import { FileText, Calendar, Bell, Home } from 'lucide-react'
import { useAuth } from '@/features/auth/hooks/useAuth'

export function ExtranetDashboard() {
  const { data: auth } = useAuth()

  const stats = [
    {
      label: 'Documents',
      value: '12',
      icon: FileText,
      color: 'blue.500',
      bgColor: 'blue.50',
    },
    {
      label: 'Prochaine AG',
      value: '15 Jan',
      icon: Calendar,
      color: 'brand.500',
      bgColor: 'brand.50',
    },
    {
      label: 'Notifications',
      value: '3',
      icon: Bell,
      color: 'orange.500',
      bgColor: 'orange.50',
    },
    {
      label: 'Ma résidence',
      value: auth?.residences[0]?.residences?.name || 'N/A',
      icon: Home,
      color: 'green.500',
      bgColor: 'green.50',
    },
  ]

  return (
    <Box>
      {/* Header */}
      <Box mb={8}>
        <Heading size="xl" mb={2} color="gray.900">
          Bienvenue,{' '}
          {auth?.profile?.first_name ||
            auth?.user?.email?.split('@')[0] ||
            'Copropriétaire'} 👋
        </Heading>
        <Text color="gray.600" fontSize="lg">
          Voici un aperçu de votre espace copropriétaire
        </Text>
      </Box>

      {/* Stats Grid */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap={6} mb={8}>
        {stats.map((stat) => {
          const IconComponent = stat.icon
          return (
            <Box
              key={stat.label}
              p={6}
              bg="white"
              borderRadius="xl"
              border="1px solid"
              borderColor="gray.200"
              boxShadow="sm"
              transition="all 0.2s"
              _hover={{
                boxShadow: 'md',
                transform: 'translateY(-2px)',
              }}
            >
              <Flex align="center" justify="space-between" mb={4}>
                <Box
                  p={3}
                  bg={stat.bgColor}
                  borderRadius="lg"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <IconComponent size={24} color={stat.color} />
                </Box>
              </Flex>
              <Text fontSize="3xl" fontWeight="bold" color="gray.900" mb={1}>
                {stat.value}
              </Text>
              <Text fontSize="sm" color="gray.600">
                {stat.label}
              </Text>
            </Box>
          )
        })}
      </SimpleGrid>

      {/* Coming Soon Sections */}
      <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6}>
        <Box
          p={8}
          bg="white"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="start" gap={4}>
            <Heading size="md" color="gray.900">
              Dernières actualités
            </Heading>
            <Text color="gray.600">
              Restez informé des dernières nouvelles de votre copropriété
            </Text>
            <Text fontSize="sm" color="brand.800" fontWeight="medium">
              Fonctionnalité à venir...
            </Text>
          </VStack>
        </Box>

        <Box
          p={8}
          bg="white"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="start" gap={4}>
            <Heading size="md" color="gray.900">
              Mes appels de fonds
            </Heading>
            <Text color="gray.600">
              Consultez vos charges et effectuez vos paiements en ligne
            </Text>
            <Text fontSize="sm" color="brand.800" fontWeight="medium">
              Fonctionnalité à venir...
            </Text>
          </VStack>
        </Box>
      </SimpleGrid>
    </Box>
  )
}
